<template>
    <div class="card">
        <div class="card-body">
            <div class="flex flex-col items-center justify-between md:flex-row">
                <div class="mb-6 md:mb-0 md:w-1/3 w-full">
                    <select v-model="usersType" @change="refreshFilteredUsers" class="selectpicker" data-style="btn-primary btn-sm" data-width="auto">
                        <option value="active">{{ $t('users.active_users') }}</option>
                        <option value="deleted">{{ $t('users.deleted_users') }}</option>
                        <option value="join-requests">{{ $t('users.join_requests') }}</option>
                    </select>
                </div>
                <div class="flex justify-center lg:justify-center md:justify-end md:w-1/3 w-full">
                    <input v-model="searchQuery" @input="refreshFilteredUsers" class="form-control input-sm w-4/5" type="search" :placeholder="$t('users.search_placeholder')">
                </div>
                <div class="hidden lg:block lg:w-1/3"></div>
            </div>
        </div>
        <div class="card-body">
            <div class="row gutter-xs">
                <div v-if="displayedUsers.length === 0" class="flex flex-col items-center justify-center w-full">
                    <div class="md:w-1/5 pb-8 w-1/2">
                        <svg-file-searching></svg-file-searching>
                    </div>
                    <div class="md:w-1/2 text-center w-full">
                        <h5>{{ $t('globals.no_results_found') }}</h5>
                        <p>{{ $t('globals.no_results_found_tip') }}</p>
                    </div>
                </div>
                <div v-else v-for="(user, index) in displayedUsers" class="col-xs-12 col-sm-6 col-md-3">
                    <user-card :key="index" :user="user"></user-card>
                </div>
                <div v-if="displayedUsers.length !== 0" class="col-xs-12">
                    <div class="text-center">
                        <ul class="pagination">
                            <li :class="{ 'disabled': currentPage === 1 }">
                                <a @click="setCurrentPage(previousPage)" href="javascript:;">&laquo;</a>
                            </li>
                            <li v-for="page in pages" :class="{ 'active': currentPage === page }">
                                <a @click="setCurrentPage(page)" href="javascript:;">{{ page }}</a>
                            </li>
                            <li :class="{ 'disabled': currentPage === lastPage }">
                                <a @click="setCurrentPage(nextPage)" href="javascript:;">&raquo;</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserCard from './partials/user-card.vue';
import SvgFileSearching from '../../svg/file-searching.vue';

export default {
    components: {
        'user-card': UserCard,
        'svg-file-searching': SvgFileSearching,
    },

    props: {
        users: {
            type: Array,
            required: true,
        },
        joinRequests: {
            type: Array,
            required: true,
        },
        perPage: {
            type: Number,
            default: 12,
        },
    },

    data() {
        const filteredUsers = this.users.filter(user => user.deleted_at === null);

        return {
            filteredUsers: filteredUsers,
            currentPage: 1,
            pages: Math.ceil(filteredUsers.length / this.perPage),
            usersType: 'active',
            searchQuery: '',
        };
    },

    computed: {
        displayedUsers() {
            const begin = (this.currentPage - 1) * this.perPage;
            const end = this.currentPage * this.perPage;
            return this.filteredUsers.slice(begin, end);
        },

        previousPage() {
            if (this.currentPage === 1) {
                return this.currentPage;
            }
            return this.currentPage - 1;
        },

        lastPage() {
            return this.pages;
        },

        nextPage() {
            if (this.currentPage === this.lastPage) {
                return this.currentPage;
            }
            return this.currentPage + 1;
        }
    },

    watch: {
        filteredUsers: function(value, old) {
            this.pages = Math.ceil(value.length / this.perPage);
            this.setCurrentPage(1);
        },
    },

    methods: {
        setCurrentPage(page) {
            this.currentPage = page;
        },

        search(query, users) {
            const filteredUsers = users.filter(user => {
                const fullName = (`${user.first_name} ${user.last_name}`).toLowerCase();
                return fullName.includes(query.toLowerCase());
            });
            return filteredUsers;
        },

        refreshFilteredUsers() {
            if (this.usersType === 'deleted') {
                this.filteredUsers = this.users.filter(user => user.deleted_at !== null);
            } else if (this.usersType === 'active') {
                this.filteredUsers = this.users.filter(user => user.deleted_at === null);
            } else if (this.usersType === 'join-requests') {
                this.filteredUsers = this.joinRequests;
            }
            this.filteredUsers = this.search(this.searchQuery, this.filteredUsers);
        }
    },
};
</script>
